import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import ArrowRightIcon from "@dcl/icons/esm/ui/arrow-right";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import Tab from "./components/Tab";
import TabList from "./components/TabList";
import TabPanel from "./components/TabPanel";
import injectPropsToChildren from "../../injectPropsToChildren";

var Flyouts = /*#__PURE__*/function (_React$Component) {
  _inherits(Flyouts, _React$Component);

  var _super = _createSuper(Flyouts);

  function Flyouts() {
    var _this;

    _classCallCheck(this, Flyouts);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Flyouts.displayName));

    _defineProperty(_assertThisInitialized(_this), "ref", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      tabs: [],
      currentOpenPanel: null,
      defaultOpenPanel: null
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var tabs = Flyouts.getFlyouts(_this.props.children);

      _this.setState({
        currentOpenPanel: null,
        defaultOpenPanel: tabs[0] && tabs[0].relatedId || null,
        tabs: tabs
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (_oldProps, oldState) {
      /*
       * Below the SiteHeader viewport width, ensure that focus is on the correct
       * Tab when closing a TabPanel.
       *
       * At or above the SiteHeader viewport width `this.state.currentOpenPanel`
       * is never `null`, so this behaviour will be skipped.
       */
      if (_this.state.currentOpenPanel === null && oldState.currentOpenPanel !== null) {
        _this.ref.querySelector("a[href=\"#".concat(oldState.currentOpenPanel, "\"]")).focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setOpenPanel", function (panelId) {
      return _this.setState({
        currentOpenPanel: panelId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabListKeyDown", function (e) {
      var siteHeaderViewportWidth = 1200;
      /*
       * Only apply this behaviour above the SiteHeader viewport width, where the
       * "tabs" UI pattern is used.
       */

      if (window.innerWidth < siteHeaderViewportWidth) {
        return;
      }

      var _this$state = _this.state,
          tabs = _this$state.tabs,
          currentOpenPanel = _this$state.currentOpenPanel;
      var currentOpenPanelIndex = tabs.findIndex(function (tab) {
        return tab.relatedId === currentOpenPanel;
      });
      var direction = getComputedStyle(_this.ref).direction;
      var nextKey = "ArrowDown";
      var previousKey = "ArrowUp";
      var focusPanelKey = direction === "ltr" ? "ArrowRight" : "ArrowLeft";

      if ([nextKey, previousKey].includes(e.key)) {
        var newOpenPanel;

        if (e.key === previousKey) {
          newOpenPanel = tabs[Math.max(0, currentOpenPanelIndex - 1)].relatedId;
        } else {
          newOpenPanel = tabs[Math.min(_this.state.tabs.length - 1, currentOpenPanelIndex + 1)].relatedId;
        }

        _this.setOpenPanel(newOpenPanel);
      }

      if (e.key === focusPanelKey || e.key === "Tab") {
        // See https://inclusive-components.design/tabbed-interfaces/#aproblemreadingpanels
        var openPanel = _this.ref.querySelector("#".concat(_this.state.currentOpenPanel));

        if (openPanel) {
          openPanel.focus();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (e, relatedId) {
      e.preventDefault();
      var siteHeaderViewportWidth = 1200;

      _this.setOpenPanel(relatedId);
      /*
       * Only apply this behaviour below the SiteHeader viewport width, where the
       * "sliding panels" UI pattern is used.
       */


      if (window.innerWidth < siteHeaderViewportWidth) {
        _this.ref.querySelector("#".concat(relatedId)).focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "registerRef", function (ref) {
      if (ref) {
        _this.ref = ref;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabPanelChildren", function (children) {
      return injectPropsToChildren(children, function (child) {
        var type = child.type,
            props = child.props;

        if (type === TabPanel) {
          return {
            setOpenPanel: _this.setOpenPanel,
            currentOpenPanel: _this.state.currentOpenPanel,
            defaultOpenPanel: _this.state.defaultOpenPanel
          };
        }

        return props;
      });
    });

    return _this;
  }

  _createClass(Flyouts, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          summaryLinkHref = _this$props.summaryLinkHref,
          summaryLinkText = _this$props.summaryLinkText;
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          modifiers: summaryLinkHref && summaryLinkText && "withSummaryLink"
        }),
        ref: this.registerRef,
        "data-rehydratable": getRehydratableName(Flyouts.displayName),
        "data-summary-link-href": summaryLinkHref,
        "data-summary-link-text": summaryLinkText
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "list"
        })
      }, /*#__PURE__*/React.createElement(TabList, null, this.state.tabs.map(function (tab) {
        return /*#__PURE__*/React.createElement(Tab, _extends({}, tab, {
          key: tab.relatedId,
          onClick: _this2.handleTabClick,
          onKeyDown: _this2.handleTabListKeyDown,
          selected: tab.relatedId === _this2.state.currentOpenPanel || _this2.state.currentOpenPanel === null && tab.relatedId === _this2.state.defaultOpenPanel
        }));
      })), summaryLinkHref && summaryLinkText && /*#__PURE__*/React.createElement("a", {
        className: this.getClassName({
          descendantName: "summaryLink"
        }),
        href: summaryLinkHref,
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "summaryLinkText"
        })
      }, summaryLinkText), /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "summaryLinkIcon"
        })
      }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
        width: 16
      })))), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "panel"
        })
      }, this.handleTabPanelChildren(children)));
    }
  }]);

  return Flyouts;
}(React.Component);

_defineProperty(Flyouts, "displayName", "SiteHeaderFlyouts");

_defineProperty(Flyouts, "getDerivedStateFromProps", function (props, state) {
  var tabs = Flyouts.getFlyouts(props.children);

  if (tabs.length === 0) {
    return _objectSpread(_objectSpread({}, state), {}, {
      tabs: tabs,
      currentOpenPanel: null
    });
  }

  return state;
});

_defineProperty(Flyouts, "getFlyouts", function (children) {
  var tabProps = [];
  React.Children.forEach(children, function (child) {
    var type = child.type;
    var props = child.props;

    if (type === TabPanel) {
      tabProps.push({
        title: props.tabTitle,
        relatedId: props.id
      });
    }

    if (type === React.Fragment) {
      tabProps.push.apply(tabProps, _toConsumableArray(Flyouts.getFlyouts(props.children)));
    }
  });
  return tabProps;
});

_defineProperty(Flyouts, "TabPanel", TabPanel);

export default Flyouts;